import { Link } from 'react-router-dom';
import type { Collection } from '@/mocks/collections';

export function formatViews(views: number) {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return String(views);
}

interface Props {
  item: Collection;
  featured?: boolean;
  index?: number;
}

export default function CollectionCard({ item, featured = false, index = 0 }: Props) {
  return (
    <article
      className={`group bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col transition-colors hover:border-primary-300 ${
        featured ? 'lg:flex-row' : ''
      }`}
    >
      <Link
        to={`/collections/${item.id}`}
        className={`relative block overflow-hidden ${featured ? 'lg:w-1/2' : ''}`}
        style={{ animationDelay: `${index * 60}ms` }}
        aria-label={item.title}
      >
        <div className={`w-full ${featured ? 'h-56 lg:h-full lg:min-h-[320px]' : 'h-44 md:h-48'}`}>
          <img
            src={item.cover}
            alt={`${item.title} - ${item.category}专题封面`}
            title={`${item.title} 合集汇总`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
          />
        </div>
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-background-50/95 text-[11px] label-font text-primary-700 border border-primary-200">
          <i className="ri-price-tag-3-line"></i>
          {item.category}
        </span>
      </Link>

      <div className={`p-4 md:p-5 flex flex-col ${featured ? 'lg:w-1/2' : ''}`}>
        <h3 className={`font-heading font-bold text-foreground-950 ${featured ? 'text-xl md:text-2xl' : 'text-base md:text-lg'}`}>
          <Link to={`/collections/${item.id}`} className="hover:text-primary-600 transition-colors">
            {item.title}
          </Link>
        </h3>
        <p className={`mt-2 text-foreground-600 leading-relaxed ${featured ? 'text-sm md:text-[15px]' : 'text-sm'} line-clamp-3`}>
          {item.summary}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-50 text-secondary-700 text-[11px] label-font border border-secondary-100"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-auto pt-4 flex items-center justify-between text-[11px] md:text-xs text-foreground-500 label-font">
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {item.updatedAt}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(item.views)}
            </span>
          </span>
          <span className="text-primary-600 flex items-center gap-1 whitespace-nowrap">
            {item.entries.length} 个节点
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </article>
  );
}